<template lang="pug">
.slot-location(v-if="haveItemsInLocation && locationTotalSlotsQuantity")
  .slot-location__header {{ location }} -
    b {{ locationTotalSlotsQuantity }} 
    | {{ date | DOWDutch }} {{ date | formattedDate }}
  .slot-location__content
    .slot-location__part(data-test="reserved-location" v-if="isTopActive")
      .slot-location__part-header TOPCBR
      .slot-table
        item(v-for="(reserved, index) in topCBRItems" :key="index" :item="reserved")
    .slot-location__part( v-if="isMijnActive")
      .slot-location__part-header MIJN
      .slot-table
        item(v-for="(reserved, index) in mijnItems" :key="index" :item="reserved")
</template>

<script>

import { RESERVED_TYPE } from '../core/reserved-const'
export default {
  props: {
    location: String,
    items: Array,
    date: String
  },

  inject: ['topActive', 'mijnActive', 'allActive'],

  data: () => ({
  }),

  computed: {

    haveItemsInLocation() {
      if(this.items && this.items.length) return true
      return false
    },

    locationTotalSlotsQuantity() {
      let items
      if(this.isAllActive) items = this.items
      else if(this.isTopActive) items = this.topCBRItems.filter(item => item.type === RESERVED_TYPE.TOP)
      else if(this.isMijnActive) items = this.mijnItems.filter(item => item.type === RESERVED_TYPE.MIJN)
      return items.reduce((acc, item) => acc + item.quantity, 0)
    },

    topCBRItems() {
      return this.items.filter(item => item.type === RESERVED_TYPE.TOP)
    },

    mijnItems() {
      return this.items.filter(item => item.type === RESERVED_TYPE.MIJN)
    },

    isTopActive() {
      return this.topActive()
    },
    isMijnActive() {
      return this.mijnActive()
    },
    isAllActive() {
      return this.allActive()
    },
  },

  components: {
    item: () => import('./ReservedItem.vue')
  }
}
</script>

<style lang="scss" scoped>
.slot-location {
  &__header {
    padding: 14px;
    background-color: lighten($color: #E5E5E5, $amount: 7);
    font-size: 13px;
    border: 1px solid #000;
    // box-shadow: 1px 1px 1px 0px #ccc;
  }
  &__content {
    display: flex;
  }
  &__part {
    width: 100%;
    &:first-child {
      border-right:1px solid #000;
    }
    &-header {
      // background-color: $app-bg-color;
      font-size: 12px;
      text-align: center;
      padding-top: 5px;
      padding-bottom: 5px;
      border-bottom: 1px solid $border-color;
    }
  }
}
</style>

<style lang="scss">
.slot-table {
  &__header {
    padding: 0 8px;
    border-bottom: 1px solid $border-color;
    display: flex;
  }
  &__cell {
    border-right: 1px solid $border-color;
    font-size: 11px;
    &:last-child {
      border-right: unset;
    }
    width: 100%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 5px 0;
  }
  &__item {
    display: flex;
    border-bottom: 1px solid $border-color;
  }
}
</style>
